module.exports = __webpack_public_path__ + "img/wick.6ebfbfb5.jpeg";